import { render, staticRenderFns } from "./AtomSimpleText.vue?vue&type=template&id=7b9b1638&"
import script from "./AtomSimpleText.vue?vue&type=script&lang=js&"
export * from "./AtomSimpleText.vue?vue&type=script&lang=js&"
import style0 from "./AtomSimpleText.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AtomSimpleText.vue"
export default component.exports